<div class="workflow-outlet-container">
    <router-outlet></router-outlet>
</div>